// A window report's dates ("Mar 23 – Apr 12"), shared by the header band, the ownership view's lines and the picker.
import dayjs from "dayjs";
import type { ReportWindow } from "./OverviewPage/Header/types";

export function windowRange(window: Pick<ReportWindow, "from" | "to"> | null | undefined): string {
  if (!window?.from || !window.to) return "";
  const f = dayjs(window.from);
  const t = dayjs(window.to);
  return f.isSame(t, "day") ? f.format("MMM D") : `${f.format("MMM D")} – ${t.format("MMM D")}`;
}
